/* src/app/navbar/navbar.component.scss */
:host {
  display: block;
  height: 60px;
}
.navbar {
  height: 60px;
  padding: 0.5rem 1rem;
  z-index: 1001 !important;
}
.navbar .navbar-toggler-icon {
  height: 30px;
  width: 30px;
}
.user-avatar {
  border-radius: 50%;
  display: inline-block;
  height: 36px;
  min-width: 36px;
  overflow: hidden;
  width: 36px;
}
.user-avatar img {
  height: 100%;
  width: 100%;
}
.portals-button span {
  display: inline-block;
  vertical-align: middle;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.portals-button .icon {
  height: 15px;
  width: 15px;
  fill: #000;
  margin-left: 5px;
}
.portal-dropdown-menu {
  position: relative;
  display: inline-block;
}
.portal-dropdown-menu .dropdown-menu {
  max-width: 320px;
  overflow: hidden;
  max-height: 420px;
  overflow-y: auto;
  background-clip: border-box;
}
.portal-dropdown-menu .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  padding: 0.25rem 1rem;
}
.portal-dropdown-menu .dropdown-menu .dropdown-item:hover {
  cursor: pointer;
}
.portal-dropdown-menu .dropdown-menu .dropdown-item .portal-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  width: 25px;
  margin-right: 7px;
}
.portal-dropdown-menu .dropdown-menu .dropdown-item .portal-logo .portal-logo-img {
  max-height: 25px;
  max-width: 25px;
}
.portal-dropdown-menu .dropdown-menu .dropdown-item .portal-name {
  max-width: 88%;
  overflow: hidden;
  text-overflow: ellipsis;
}
form input {
  min-width: 300px;
}
form input::-ms-clear {
  display: none;
}
.wrapper-for-input-with-clear-button input {
  padding-right: 24px;
}
.wrapper-for-input-with-clear-button button {
  background-color: transparent;
  border: none;
  color: rgb(103, 106, 108);
  cursor: pointer;
  font-size: 13px;
  height: 36px;
  margin: 0;
  opacity: 1;
  outline: none;
  padding: 0;
  position: absolute;
  right: 1px;
  top: 1px;
  width: 24px;
  z-index: 3;
}
.navbar-toggler {
  opacity: 0.6 !important;
  border: none !important;
  padding: 4px 6px !important;
  outline: none !important;
  box-shadow: none !important;
}
.navbar-toggler:hover {
  background-color: #d4d4d4;
}
.navbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.bg-light {
  background-color: #f8f9fa !important;
}
@media (min-width: 992px) {
  .navbar-expand-lg .navbar-toggler {
    display: block;
  }
}
@media (max-width: 900px) {
  .portal-dropdown-menu .dropdown-toggle span {
    max-width: 200px;
  }
}
@media (max-width: 730px) {
  :host {
    height: 120px;
  }
  .navbar {
    height: 120px;
  }
  .navbar form {
    order: 10;
    width: 100% !important;
    margin-bottom: 0.5rem !important;
    margin-top: 0.5rem !important;
  }
  .navbar form .input-group {
    width: 100%;
  }
  .navbar form .input-group input {
    min-width: auto !important;
  }
}
@media (max-width: 420px) {
  .portal-dropdown-menu .dropdown-menu {
    max-width: calc(100vw - 100px) !important;
    max-height: calc(100vh - 60px) !important;
  }
}
/*# sourceMappingURL=navbar.component.css.map */
